import { useEffect } from 'react'
import { Link, useNavigate } from 'react-router'
import { useSearchParams } from 'react-router'
import { toast } from 'sonner'
import { useTranslation } from 'react-i18next'

import { SetPasswordForm } from '@/forms/SetPasswordForm/SetPasswordForm'
import { AuthLayout } from '@/layouts/AuthLayout'

export default function ResetPasswordPage() {
  const { t } = useTranslation()
  const [searchParams] = useSearchParams()
  const code = searchParams.get('code')
  const email = searchParams.get('email')

  const navigate = useNavigate()

  useEffect(() => {
    if (!code || !email) {
      navigate('/auth/login')
    }
  }, [code, email, navigate])

  return (
    <AuthLayout hideFooter>
      <title>{t('resetPassword.title')}</title>

      <SetPasswordForm
        action="/auth/reset-password"
        code={code}
        email={email}
        onSuccess={async (response: any) => {
          if (response.status > 400) {
            toast.error(t('resetPassword.errors.invalidCode.title'), {
              description: t('resetPassword.errors.invalidCode.description'),
              duration: 5000,
              onDismiss: () => navigate('/auth/reset-password'),
            })
            return
          }

          if (response.status === 200 || response.status === 204) {
            toast.success(t('resetPassword.success.title'), {
              description: t('resetPassword.success.description'),
              duration: 5000,
              onDismiss: () => navigate('/auth/login'),
            })

            navigate('/auth/login')
          }
        }}
      />

      <div className="px-8 pb-8 text-center sm:px-12">
        <Link
          to="/auth/login"
          className="font-label text-brand-primary hover:text-brand-primary-dark"
        >
          {t('resetPassword.backToLogin')}
        </Link>
      </div>
    </AuthLayout>
  )
}
